"use client";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const ByuAlert = withReactContent(Swal);

export const showAlert = (params: {
  title?: string;
  text?: string;
  icon?: "success" | "error" | "warning" | "info" | "question";
  confirmButtonText?: string;
  cancelButtonText?: string;
  showCancelButton?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}) => {
  ByuAlert.fire({
    title: params.title,
    text: params.text,
    icon: params.icon,
    showCancelButton: params.showCancelButton,
    confirmButtonText: params.confirmButtonText,
    cancelButtonText: params.cancelButtonText,
    customClass: {
      popup: "custom-swal-popup",
      title: "custom-swal-title",
      confirmButton: "custom-swal-confirm",
      cancelButton: "custom-swal-cancel",
    },
  }).then((result) => {
    if (result.isConfirmed && params?.onConfirm) {
      params?.onConfirm();
    } else if (result.isDismissed && params?.onCancel) {
      params?.onCancel();
    }
  });
};
export type ToastParams = {
  title: string;
  icon?: "success" | "error" | "warning" | "info";
  timer?: number;
};
// ✅ Toast Notification
export const showToast = ({
  title,
  icon = "success",
  timer = 3000,
}: ToastParams) => {
  Swal.fire({
    title,
    icon,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer,
    timerProgressBar: true,
    customClass: {
      popup: "custom-toast-popup",
    },
  });
};
